module.exports = window["nab"]["date"];